import axios from 'axios';


// Default config options
const defaultOptions = {
    baseURL: 'https://pooldecompras.cimcc.org.ar/Api/public',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  let clienteAxios = axios.create(defaultOptions);

  // Set the AUTH token for any request
  clienteAxios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
  });

export default clienteAxios;